import React, { useState } from "react";
import { Facebook, Instagram, Linkedin, Youtube, Mail, Phone } from "lucide-react";
import { contact, socials } from "../mock";
import { useToast } from "../hooks/use-toast";

const iconFor = (name) => {
  const props = { className: "w-5 h-5" };
  switch (name) {
    case "Facebook":
      return <Facebook {...props} />;
    case "Instagram":
      return <Instagram {...props} />;
    case "LinkedIn":
      return <Linkedin {...props} />;
    case "YouTube":
      return <Youtube {...props} />;
    default:
      return null;
  }
};

const Footer = () => {
  const [email, setEmail] = useState("");
  const { toast } = useToast();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email) return;
    const list = JSON.parse(localStorage.getItem("bot_mailing_list") || "[]");
    list.push({ email, at: new Date().toISOString() });
    localStorage.setItem("bot_mailing_list", JSON.stringify(list));
    toast({
      title: "You're on the list!",
      description: "Thanks for joining the BOT mailing list.",
    });
    setEmail("");
  };

  return (
    <footer className="bg-[#0a0a0a] border-t border-[#2a2a2a] mt-16">
      <div className="max-w-6xl mx-auto px-6 py-16 grid md:grid-cols-3 gap-12">
        <div>
          <h4 className="font-display text-xl text-[#e8a13a] mb-4">FIND US ON SOCIALS</h4>
          <div className="flex gap-4">
            {socials.map((s) => (
              <a
                key={s.name}
                href={s.url}
                target="_blank"
                rel="noreferrer"
                className="w-10 h-10 rounded-full border border-[#3a3a3a] flex items-center justify-center text-[#f5f1e8] hover:text-[#e8a13a] hover:border-[#e8a13a] transition-colors"
                aria-label={s.name}
              >
                {iconFor(s.name)}
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="font-display text-xl text-[#e8a13a] mb-4">JOIN THE BOT MAILING LIST</h4>
          <p className="text-sm text-[#c8bfae] mb-4">
            Keep in the loop on the latest and greatest happening with Brains On Tap Canada!
          </p>
          <form onSubmit={handleSubmit} className="flex gap-2">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email"
              className="flex-1 bg-[#181818] border border-[#3a3a3a] px-4 py-2 text-sm text-[#f5f1e8] focus:outline-none focus:border-[#e8a13a]"
            />
            <button
              type="submit"
              className="bg-[#e8a13a] hover:bg-[#d18f28] text-[#0f0f10] font-semibold px-5 py-2 text-sm tracking-wider transition-colors"
            >
              Sign up
            </button>
          </form>
        </div>

        <div>
          <h4 className="font-display text-xl text-[#e8a13a] mb-4">BRAINS ON TAP</h4>
          <p className="text-sm text-[#c8bfae] mb-3">The Non-Lecture Experience</p>
          <a
            href={`tel:${contact.phone}`}
            className="flex items-center gap-2 text-sm text-[#f5f1e8] hover:text-[#e8a13a] mb-2"
          >
            <Phone className="w-4 h-4" /> {contact.phone}
          </a>
          <a
            href={`mailto:${contact.email}`}
            className="flex items-center gap-2 text-sm text-[#f5f1e8] hover:text-[#e8a13a]"
          >
            <Mail className="w-4 h-4" /> {contact.email}
          </a>
        </div>
      </div>
      <div className="border-t border-[#2a2a2a] py-5 text-center text-xs text-[#7d7568]">
        Copyright © 2026 Brains On Tap Canada — All Rights Reserved.
      </div>
    </footer>
  );
};

export default Footer;
